import { render } from "./StatusSelect.vue?vue&type=template&id=1add7207&scoped=true"
import script from "./StatusSelect.vue?vue&type=script&lang=js"
export * from "./StatusSelect.vue?vue&type=script&lang=js"

import "./StatusSelect.vue?vue&type=style&index=0&id=1add7207&scoped=true&lang=css"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1add7207"]])

export default __exports__